export class WelcomeService {
    static $inject = ['ProfileCommandProcessor'];
    constructor(ProfileCommandProcessor) {
        'ngInject';
        this.ProfileCommandProcessor = ProfileCommandProcessor;
    }
    // Welcome message
    getGreeting(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'greeting');
    }
    saveGreeting(application, greeting) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'greeting', 'text/plain', greeting);
    }
    deleteGreeting(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'greeting');
    }
    // Button postback
    getGetStarted(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'get-started');
    }
    saveGetStarted(application, getStarted) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'get-started', 'text/plain', getStarted);
    }
    deleteGetStarted(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'get-started');
    }
    // Button label
    getGetStartedLabel(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'get-started-label');
    }
    saveGetStartedLabel(application, getGetStartedLabel) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'get-started-label', 'text/plain', getGetStartedLabel);
    }
    deleteGetStartedLabel(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'get-started-label');
    }
}
WelcomeService.$inject = ['ProfileCommandProcessor'];
